export enum AppUploadHandlerMutationTypes {
  SET_UPLOAD_HINT = 'SET_UPLOAD_HINT',
  ADD_FILE_TO_UPLOAD = 'ADD_FILE_TO_UPLOAD',
  ADD_TO_QUEUE = 'ADD_TO_QUEUE',
  INCREMENT_UPLOAD_IN_PROGRESS = 'INCREMENT_UPLOAD_IN_PROGRESS',
  DECREMENT_UPLOAD_IN_PROGRESS = 'DECREMENT_UPLOAD_IN_PROGRESS',
  SET_FILE_STATUS_TO_PENDING = 'SET_FILE_STATUS_TO_PENDING',
  REDO_ALL_ERRORED_DOCUMENTS = 'REDO_ALL_ERRORED_DOCUMENTS',
  RESET = 'RESET',
}
